<template>
  <copy-button :disabled="disabled" :text="text">
    <span class="button-text truncate text-headline">
      <span v-if="separator">,</span>
      {{ value || missingValueText }}
    </span>
  </copy-button>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { format, parseISO } from "date-fns";

import {
  DATE_REGEX_VALIDATE,
  SLASH_DATE_FORMAT,
} from "@/helpers/constants/dateTime";

import CopyButton from "@/components/ui/buttons/CopyButton.vue";

const {
  text = "",
  missingValueText = "-",
  separator = false,
  disabled = false,
} = defineProps<{
  text?: string | number;
  missingValueText?: string;
  separator?: boolean;
  disabled?: boolean;
}>();

const value = computed(() => {
  if (typeof text !== "string" || !DATE_REGEX_VALIDATE.test(text)) {
    return text;
  }

  return format(parseISO(text), SLASH_DATE_FORMAT);
});
</script>

<style scoped>
@reference "@/assets/tailwind.css";

.button-text {
  word-break: break-word;
}
</style>
